import { ReactComponent as Cash } from "../img/icons/tresorerie.svg";
import { ReactComponent as Products } from "../img/icons/produit.svg";
import { ReactComponent as Prelevement } from "../img/icons/ooredoo.svg";
// import { ReactComponent as RC } from "../img/icons/registre commerce .svg";
import { ReactComponent as COD } from "../img/icons/grossiste.svg";
import { ReactComponent as R } from "../img/icons/retail.svg";
import { ReactComponent as Bu } from "../img/icons/bu.svg";
import { ReactComponent as Secteur } from "../img/icons/secteur.svg";
import { ReactComponent as Frns } from "../img/icons/fournisseur.svg";
import { ReactComponent as Stromi } from "../img/icons/storm strock.svg";
import { ReactComponent as Voucher } from "../img/icons/voucher fill.svg";
import { ReactComponent as Scratch } from "../img/icons/scratch.svg";
import { ReactComponent as Sim } from "../img/icons/sim.svg";
import { ReactComponent as Prv } from "../img/icons/prelevement2.svg";
import { ReactComponent as Stock } from "../img/icons/storage.svg";
import { ReactComponent as Chq } from "../img/icons/cheque bancaire-01.svg";
// import { ReactComponent as Vir } from "../img/icons/virement bancaire-01.svg";
import { ReactComponent as Vir } from "../img/icons/virement bancaire icon2.svg";
import { ReactComponent as Thermalpaper } from "../img/icons/thermo papr-01-01.svg";
import { ReactComponent as Charge } from "../img/icons/charge icon2.svg";
import { ReactComponent as Commandes } from "../img/icons/commande icon.svg";
import { ReactComponent as Cpt } from "../img/icons/compt bancaire icon2.svg";
import { ReactComponent as Creance } from "../img/icons/creance icon2.svg";
import { ReactComponent as Historique } from "../img/icons/historique icon2.svg";
import { ReactComponent as Rapp } from "../img/icons/rapprochement icon2.svg";
import { ReactComponent as Nrc } from "../img/icons/RC icon2.svg";
import { ReactComponent as Role } from "../img/icons/role icon2.svg";
import { ReactComponent as Trnsfr } from "../img/icons/transfr icon2.svg";
import { ReactComponent as Typchg } from "../img/icons/type de charge icon2 .svg";
import { ReactComponent as Dmp } from "../img/icons/demande de paiment 2.svg";
import { ReactComponent as Vrs } from "../img/icons/versements.svg";
import { ReactComponent as Pay } from "../img/icons/payment.svg";
import { ReactComponent as Fac } from "../img/icons/facture.svg";
import { ReactComponent as Trk } from "../img/icons/sim tracking.svg";

//web
import { ReactComponent as Fran } from "../img/icons/franchise.svg";
import { ReactComponent as Sld } from "../img/icons/moneybag.svg";
import { ReactComponent as Whs } from "../img/icons/warehouse.svg";
import { ReactComponent as Cshf } from "../img/icons/cashflow.svg";
import { ReactComponent as Dgt } from "../img/icons/digital5.svg";
import { ReactComponent as Prf } from "../img/icons/performance2.svg";
import { ReactComponent as Supervise } from "../img/icons/supervise.svg";
import { ReactComponent as Recouv } from "../img/icons/cashback2.svg";
import { ReactComponent as Path } from "../img/icons/path.svg";
import { ReactComponent as CshCtrl } from "../img/icons/cash-wrench.svg";
import { ReactComponent as Recruits } from "../img/icons/recruites.svg";
import { ReactComponent as Timefan } from "../img/icons/timefan.svg";

import React from "react";

export function GetIconName(menu) {
  switch (menu) {
    case "A PROPOS":
    case "A propos":
      return "mdiInformation";
    case "ENTREPRISES":
    case "Entreprises":
      return "mdiCity";
    case "Employés":
      return "mdiAccountTie";
    case "Contrats":
      return "mdiFileDocumentEdit";
    case "Postes":
      return "mdiBriefcase";
    case "Unités":
      return "mdiOfficeBuilding";
    case "Banques":
      return "mdiBank";
    case "Conventions":
      return "mdiHumanCapacityIncrease";
    case "Signataires":
      return "mdiDrawPen";
    case "Admin.":
      return "mdiSecurity";
    case "Mailing":
      return "mdiGmail";
    case "SMSing":
      return "mdiMessageText";
    case "Validatons":
      return "mdiCheck";
    case "Export":
      return "mdiFileTableBoxMultiple";
    case "Timefan":
      //this icon has no whitespace arround it so i added padding to make it look like trhe others
      return <Timefan className="icon-size-20" fill="#fff" style={{ padding: 1 }} />;
    case "Privs":
      return "mdiStarCheck";
    case "Roles":
      return <Role className="icon-size-20" fill="#fff" />;
    case "Sessions":
      return "mdiAccountClock";
    case "Utilisateurs":
      return "mdiAccountMultiple";
    case "Params":
      return "mdiCogs";
    case "CLIENTS":
      return "mdiAccountGroup";
    case "RC":
      return <Nrc className="icon-size-20" fill="#fff" />;
    case "COD":
      return <COD className="icon-size-20" fill="#fff" />;
    case "Retail":
      return <R className="icon-size-20" fill="#fff" />;
    case "Business Units":
      return <Bu className="icon-size-20" fill="#fff" />;
    case "Secteurs":
      return <Secteur className="icon-size-20" fill="#fff" />;
    case "Facturation":
      return <Fac style={{ width: "15px" }} fill="#fff" />;
    case "Stock":
      return <Stock className="icon-size-20" fill="#fff" />;
    case "Portefeuille":
      return "mdiAccountTie";
    case "Créances":
      return <Creance className="icon-size-20" fill="#fff" />;
    case "Historique":
      return <Historique className="icon-size-20" fill="#fff" />;
    case "MONITORING":
      return "mdiMonitorDashboard";
    case "Lettres d'offre":
      return "mdiFilePercent";
    case "Lettres d'objectif":
      return "mdiBullseyeArrow";
    case "Prélèvements":
      return <Prv className="icon-size-20" fill="#fff" />;
    case "Commandes":
      return <Commandes className="icon-size-20" fill="#fff" />;
    case "STOCK":
      return "mdiWarehouse";
    case "Tracking":
      return <Trk style={{ width: "15px" }} fill="#fff" />;
    case "Produits":
      return <Products className="icon-size-20" fill="#fff" />;
    case "VOUCHER":
      return <Voucher className="icon-size-20" fill="#fff" />;
    case "Papier thermique":
      return <Thermalpaper className="icon-size-20" fill="#fff" />;
    case "Transferts":
      return <Trnsfr className="icon-size-20" fill="#fff" />;

    case "TOPUP":
      return <Stromi className="icon-size-20" fill="#fff" />;
    case "SCRATCH":
      return <Scratch className="icon-size-20" fill="#fff" />;
    case "SIM":
      return <Sim style={{ width: "15px" }} fill="#fff" />;

    case "REFERENTIEL":
      return "mdiFolderFile";
    case "Fournisseurs":
      return <Frns className="icon-size-20" fill="#fff" />;
    case "Type de charges":
      return <Typchg className="icon-size-20" fill="#fff" />;
    case "Warehouses":
      return "mdiWarehouse";
    case "REPORTS":
      return "mdiChartBarStacked";
    case "TRESORERIE":
      return <Cash className="icon-size-20" fill="#fff" />;
    case "Chèques":
      return <Chq className="icon-size-20" fill="#fff" />;
    case "Virements":
      return <Vir className="icon-size-20" fill="#fff" />;
    case "Versements":
      // return "mdiAccountCash";
      return <Vrs className="icon-size-20" fill="#fff" />;
    case "Dem. paiements":
      // return "mdiCashClock";
      return <Dmp className="icon-size-20" />;
    case "Paiements":
      // return "mdiCashMultiple";
      return <Pay className="icon-size-20" fill="#fff" />;
    case "Rapprochements":
      return <Rapp className="icon-size-20" fill="#fff" />;
    case "Comptes":
      return <Cpt className="icon-size-20" fill="#fff" />;
    case "Charges":
      return <Charge className="icon-size-20" fill="#fff" />;
    case "Historique":
      return "mdiClipboardTextClock";
    //web
    case "Tour":
      return "mdiMapMarkerPath";
    case "Monit":
      return "mdiMonitorDashboard";
    case "Monit.":
      return "mdiMonitorDashboard";
    case "Recrues":
      return <Recruits className="icon-size-20" fill="#fff" />;
    case "Superv.":
      return "mdiEye";
    case "Manager":
      return "mdiAccountStar";
    case "Planner":
      return "mdiMapClock";

    case "Franchises":
      return <Fran className="icon-size-20" fill="#fff" />;
    case "Franchise":
      return <Fran className="icon-size-20" fill="#fff" />;
    case "Customers":
      return "mdiAccountGroup";
    case "Report":
      return "mdiFileChart";
    case "Users":
      return "mdiAccountMultiple";
    case "Stocks":
      return <Stock className="icon-size-20" fill="#fff" />;
    case "Achats":
      return "mdiCartVariant";
    case "Encaissements":
      return "mdiHandCoin";
    case "Soldes clients":
      return "mdiAccountCash";
    case "Ventes":
      return "mdiFinance";

    case "Dashboard":
      return "mdiViewDashboard";
    case "Balance":
      return <Sld className="icon-size-20" fill="#fff" />;
    case "Cashflow":
      return <Cshf className="icon-size-20" fill="#fff" />;
    case "Digital":
      return <Dgt className="icon-size-20" fill="#fff" />;
    case "Performance":
      return <Prf className="icon-size-20" fill="#fff" />;
    case "Supervise":
      return <Supervise className="icon-size-20" fill="#fff" />;
    case "Supervise":
      return <Supervise className="icon-size-20" fill="#fff" />;
    case "Wholesaler":
      return <Whs className="icon-size-20" fill="#fff" />;
    case "Recouv.":
      return <Recouv className="icon-size-20" fill="#fff" />;

    case "Histo.":
      return "mdiClipboardTextClock";
    case "Portfolio":
      return "mdiWalletBifold";
    case "Solds":
      // return <Sld className="icon-size-20" fill="#fff" />;
      return "mdiAccountCash";
    case "Routes":
      return <Path className="icon-size-20" fill="#fff" stroke="#fff" outline="#fff" />;

    case "Tools":
      return "mdiTools";
    case "Price control":
      return <CshCtrl className="icon-size-20" fill="#fff" />;
    case "Campagnes":
      return "mdiBullhorn";
    // return <Suser className="icon-size-20" fill="#fff" />;
    case "Activity":
      return "mdiBriefcaseAccount";
    case "Goals":
      return "mdiBullseyeArrow";
    case "Analytics":
      return "mdiChartBar";
    default:
      return " mdiAlertCircle";
  }
}
